// Remembers the page a visitor was trying to reach across the login detour: a QR scan opened from the phone's camera,
// a link in a notification email, or a page they were on when their session ended. localStorage (not
// sessionStorage) so it survives opening login/registration/verification links in another tab, which is common on
// phones; entries expire so a stale one can't hijack a later login. Only same-site, well-formed paths are ever stored
// or returned, so this can never be used as an open redirect.
const KEY = "anike:redirectAfterLogin";
const TTL_MS = 30 * 60 * 1000;
const MAX_LENGTH = 512;
const SAFE_PATH = /^\/(?!\/)[A-Za-z0-9._~\-/%:@+,;=!$&'()*]*(\?[A-Za-z0-9._~\-/%:@+,;=!$&'()*?]*)?$/;

const isRememberable = path =>
    typeof path === "string" &&
    path.length <= MAX_LENGTH &&
    SAFE_PATH.test(path) &&
    !path.split("?")[0].split("/").includes("..") &&
    !(path === "/" || /^\/(dashboard|auth|logout|error)(\/|\?|$)/.test(path));

export function rememberPostLoginPath(pathWithSearch) {
    if (!isRememberable(pathWithSearch)) return;
    try {
        localStorage.setItem(KEY, JSON.stringify({ path: pathWithSearch, at: Date.now() }));
    } catch (e) {
        // storage unavailable (private mode) - the page simply won't be resumed
    }
}

// Kept for the QR scan flow and its tests; a scan path is just one kind of remembered path.
export const rememberScanPath = rememberPostLoginPath;

export function peekPostLoginPath() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;
        const { path, at } = JSON.parse(raw);
        if (isRememberable(path) && Date.now() - at < TTL_MS) return path;
        localStorage.removeItem(KEY);
    } catch (e) {
        // corrupt entry - ignore
    }
    return null;
}

export function clearPostLoginPath() {
    try {
        localStorage.removeItem(KEY);
    } catch (e) {
        // ignore
    }
}

